import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from "../layouts/Layout.vue";
import Login from "../views/Login.vue";
import ChangePassword from "../views/ChangePassword.vue";

Vue.use(VueRouter)

const routes = [
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/changePassword",
    name: "ChangePassword",
    component: ChangePassword,
  },
   {
    path: "/PrintEmploymentStatement/:id",
    name: "PrintEmploymentStatement",
    component: () => import('../views/employeesManagement/employees/print/Index.vue')
  },
  {
    path: "/PrintCurrentBonus/:id",
    name: "PrintCurrentBonus",
    component: () => import('../views/employeesManagement/employees/print/Bonus.vue')
  },
  {
    path: "/PrintEmploymentBonus/:id",
    name: "PrintEmploymentBonus",
    component: () => import('../views/employeeOperations/employeeBonuses/print/Index.vue')
  }, 
  {
    path: "/PrintBonusStatement/:id",
    name: "PrintBonusStatement",
    component: () => import('../views/reports/bonusesReport/print/Index.vue')
  },
  {
    path: "/PrintLeave/:id",
    name: "PrintLeave",
    component: () => import('../views/employeeOperations/employeeLeaves/print/Index.vue')
  },
  {
    path: '/',
    name: 'Layout',
    component: Layout,
    redirect: "dashboard",
    children: [

   
      {
        path: 'search',
        name: 'search',
        component: () => import('../views/search/Index.vue')
      }, {
        path: 'dashboard',
        name: 'dashboard',
        component: () => import('../views/dashboard/Index.vue')
      },
      {
        path: "employees",
        name: "employees",
        component: () =>
          import("../views/employeesManagement/employees/Index.vue"),
        props:(route)=>({
          query:route.query.payload
        }),
      },
      {
        path: "employeeHealth",
        name: "employeeHealth",
        component: () =>
          import("../views/employeesManagement/employeeHealth/Index.vue"),
      },
      {
        path: "employeeQualifications",
        name: "employeeQualifications",
        component: () =>
          import("../views/employeesManagement/employeeQualifications/Index.vue"),
      },
      {
        path: "complaints",
        name: "complaints",
        component: () =>
          import("../views/employeeOperations/complaints/Index.vue"),
      },
      {
        path: "employeeCourses",
        name: "employeeCourses",
        component: () =>
          import("../views/employeesManagement/employeeCourses/Index.vue"),
      },
      {
        path: "employeeTransfers",
        name: "employeeTransfers",
        component: () =>
          import("../views/employeeOperations/employeeTransfers/Index.vue"),
      },
      {
        path: "employeeDelegations",
        name: "employeeDelegations",
        component: () =>
          import("../views/employeeOperations/employeeDelegations/Index.vue"),
      },
      {
        path: "degreeDelegnations",
        name: "degreeDelegnations",
        component: () =>
          import("../views/employeeOperations/degreeDelegnations/Index.vue"),
      },
      {
        path: "bonuses",
        name: "bonuses",
        component: () =>
          import("../views/employeeOperations/employeeBonuses/Index.vue"),
      },
      {
        path: "promotions",
        name: "promotions",
        component: () =>
          import("../views/employeeOperations/employeePromotions/Index.vue"),
      },
      {
        path: "grievances",
        name: "grievances",
        component: () =>
          import("../views/employeeOperations/grievances/Index.vue"),
      }, {
        path: "employeesCorrection",
        name: "employeesCorrection",
        component: () =>
          import("../views/employeeOperations/employeeCorrection/Index.vue"),
      },

      {
        path: "employeeNotifications",
        name: "employeeNotifications",
        component: () =>
          import("../views/employeeOperations/employeeNotifications/Index.vue"),
      },

      {
        path: "directorsAppointments",
        name: "directorsAppointments",
        component: () =>
          import("../views/employeeOperations/directorsAppointments/Index.vue"),
      },
      {
        path: "employeeLeaves",
        name: "employeeLeaves",
        component: () =>
          import("../views/employeeOperations/employeeLeaves/Index.vue"),
      },
      {
        path: "retirements",
        name: "retirements",
        component: () =>
          import("../views/employeeOperations/retirements/Index.vue"),
      },
      {
        path: "departments",
        name: "departments",
        component: () =>
          import("../views/settings/departments/Index.vue"),
      },
      {
        path: "users",
        name: "users",
        component: () =>
          import("../views/settings/users/Index.vue"),
      },
      {
        path: "organization",
        name: "organization",
        component: () =>
          import("../views/settings/organization/Index.vue"),
      },
      {
        path: "attendanceDailyReport",
        name: "attendanceDailyReport",
        component: () =>
          import("../views/reports/attendanceDailyReport/Index.vue"),
      },
      {
        path: "attendanceMonthlyReport",
        name: "attendanceMonthlyReport",
        component: () =>
          import("../views/reports/attendanceMonthlyReport/Index.vue"),
      },
      {
        path: "attendanceEmployeeReport",
        name: "attendanceEmployeeReport",
        component: () =>
          import("../views/reports/attendanceEmployeeReport/Index.vue"),
      },
      {
        path: "attendanceAdjustments",
        name: "attendanceAdjustments",
        component: () => import("../views/settings/attendanceAdjustments/Index.vue"),
      },
      {
        path: "attendancePunches",
        name: "attendancePunches",
        component: () =>
          import("../views/settings/attendancePunches/Index.vue"),
      },
      {
        path: "attendanceDevices",
        name: "attendanceDevices",
        component: () =>
          import("../views/settings/attendanceDevices/Index.vue"),
      },
      {
        path: "workSchedules",
        name: "workSchedules",
        component: () =>
          import("../views/settings/workSchedules/Index.vue"),
      },
      {
        path: "holidays",
        name: "holidays",
        component: () =>
          import("../views/settings/holidays/Index.vue"),
      },
      {
        path: "auditLogs",
        name: "auditLogs",
        component: () =>
          import("../views/settings/auditLogs/Index.vue"),
      },
      {
        path: "jobGrades",
        name: "jobGrades",
        component: () =>
          import("../views/settings/jobGrades/Index.vue"),
      },
      {
        path: "units",
        name: "units",
        component: () =>
          import("../views/settings/units/Index.vue"),
      },
      {
        path: "universities",
        name: "universities",
        component: () =>
          import("../views/lists/universities/Index.vue"),
      },
      {
        path: "administrations",
        name: "administrations",
        component: () =>
          import("../views/settings/administrations/Index.vue"),
      },
      {
        path: "jobGroups",
        name: "jobGroups",
        component: () =>
          import("../views/lists/jobGroups/Index.vue"),
      },
      {
        path: "jobs",
        name: "jobs",
        component: () =>
          import("../views/lists/jobs/Index.vue"),
      },
      {
        path: "banks",
        name: "banks",
        component: () =>
          import("../views/lists/banks/Index.vue"),
      },
      {
        path: "specialties",
        name: "specialties",
        component: () =>
          import("../views/lists/specialties/Index.vue"),
      },
      {
        path: "assignments",
        name: "assignments",
        component: () =>
          import("../views/employeeOperations/assignments/Index.vue"),
      },
      {
        path: "notifications",
        name: "notifications",
        component: () =>
          import("../views/employeeOperations/employeeNotifications/Index.vue"),
      }, {
        path: "employeeTermination",
        name: "employeeTermination",
        component: () =>
          import("../views/employeeOperations/employeeTermination/Index.vue"),
      },
      // ----------------- reports ---------------
      {
        path: "vacationsReport",
        name: "vacationsReport",
        component: () =>
          import("../views/reports/vacationsReport/Index.vue"),
      },
      {
        path: "employeesJobs",
        name: "employeesJobs",
        component: () =>
          import("../views/reports/employeesJobs/Index.vue"),
      },
      {
        path: "bonusesReport",
        name: "bonusesReport",
        component: () =>
          import("../views/reports/bonusesReport/Index.vue"),
      },
      {
        path: "correlatorReport",
        name: "correlatorReport",
        component: () =>
          import("../views/reports/correlatorReport/Index.vue"),
      },
      {
        path: "retirementReport",
        name: "retirementReport",
        component: () =>
          import("../views/reports/retirementReport/Index.vue"),
      }, {
        path: "employeesJobGradesReport",
        name: "employeesJobGradesReport",
        component: () =>
          import("../views/reports/employeesJobGradesReport/Index.vue"),
      },
      {
        path: "localities",
        name: "localities",
        component: () =>
          import("../views/lists/localities/Index.vue"),
      },
      {
        path: "qualificationReport",
        name: "qualificationReport",
        component: () =>
          import("../views/reports/qualificationReport/Index.vue"),
      },
      {
        path: "employeeCoursesReport",
        name: "employeeCoursesReport",
        component: () =>
          import("../views/reports/employeeCoursesReport/Index.vue"),
      },
    ]
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
